import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-confirm-exit-dialog',
  standalone: true,
  imports: [
      MatDialogModule,
      MatFormFieldModule,
      MatInputModule,
      ReactiveFormsModule,
      CommonModule
    ],
  templateUrl: './confirm-exit-dialog.component.html',
  styleUrl: './confirm-exit-dialog.component.scss'
})
export class ConfirmExitModalComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmExitModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  confirmarSalida(): void {
    this.dialogRef.close(true); // Usuario acepta salir
  }

  cancelar(): void {
    this.dialogRef.close(false); // Usuario cancela
  }
}